// Single source of truth for RunPod serverless step codes → English labels. The worker reports a
// stable `progressCode` (e.g. "GENERATING_SHAPE"); the UI resolves it to human text here so the
// wording lives in one place. Mirrors the STATUS map in components/ui/StatusBadge.tsx.

const PROGRESS_LABELS: Record<string, string> = {
  PREPARING: "Preparing image",
  REMOVING_BACKGROUND: "Removing background",
  GENERATING_SHAPE: "Generating shape",
  BUILDING_MESH: "Building mesh",
  OPTIMIZING_MESH: "Optimizing mesh",
  UNWRAPPING_MESH: "Unwrapping mesh",
  GENERATING_TEXTURES: "Generating textures",
  BAKING_TEXTURES: "Baking textures",
  REFINING_TEXTURES: "Refining textures",
  EXPORTING: "Exporting model",
  FINALIZING: "Finalizing",
};

/** English label for a step code. An unknown code means this map is out of date with the worker. */
export function progressLabel(code: string): string {
  const label = PROGRESS_LABELS[code];
  if (label === undefined) throw new Error(`Unknown progress code: ${code}`);
  return label;
}
